module.exports = __webpack_public_path__ + "img/shape-octagon-alta-pagoda.f84b4a91.png";